import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, Button, Modal, Form } from 'react-bootstrap';
import { MdDesignServices } from "react-icons/md";
import './DeleteWhyUs.css';
import { jwtDecode } from 'jwt-decode';

const DeleteWhyUsCards = () => {

  const token = sessionStorage.getItem('authToken');
const currentTime = Date.now() / 1000; // Current time in seconds


  const [showModal, setShowModal] = useState(false);
  const [currentFeature, setCurrentFeature] = useState(null);
  const [updatedTitle, setUpdatedTitle] = useState('');
  const [updatedDescription, setUpdatedDescription] = useState('');
 const [isTokenValid, setIsTokenValid] = useState(true); // Token validity state
   
  const [features, setFeatures] = useState([]);
  const [error, setError] = useState("");
  const [editFeature, setEditFeature] = useState(null);

  useEffect(() => {
    const fetchFeatures = async () => {
      try {
        if (token) {
                        try {
                            const decodedToken = jwtDecode(token);
        
                            const expiryTime = decodedToken.exp; // Token expiration time from the JWT
        
                            // Check if the token is expired
                            if (expiryTime < currentTime) {
                                setIsTokenValid(false);
                                
                            } else {
                                setIsTokenValid(true);
                                // Token is still valid, continue with your logic
                            }
                        } catch (error) {
                            console.error("Error decoding the token", error);
                            setIsTokenValid(false);
                        
                        }
                    } else {
                        setIsTokenValid(false);
                        
                    }
                    
        const response = await axios.get("https://zoomautos.co.uk/api/features", {
          headers: {
            Authorization: `Bearer ${token}`, // Include token in headers
        },
        params: {
          _t: new Date().getTime(), // Add timestamp to bypass cache
        },
      
      });
        setFeatures(response.data);
      } catch (err) {
        console.error("Error fetching features:", err);
        setError("Failed to fetch features. Please try again later.");
      }
    };

    fetchFeatures();
  }, []);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://zoomautos.co.uk/api/features/${id}`,
        {
          headers: {
              Authorization: `Bearer ${token}`, // Add the token to the header
          },
      }

      );
      setFeatures((prevFeatures) =>
        prevFeatures.filter((feature) => feature._id !== id)
      );
    } catch (err) {
      console.error("Error deleting feature:", err);
      setError("Failed to delete feature. Please try again later.");
    }
  };

  const handleEdit = (feature) => {
    setEditFeature(feature);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`https://zoomautos.co.uk/api/features/${editFeature._id}`, {
        title: editFeature.title,
        description: editFeature.description,
      });
      setFeatures((prevFeatures) =>
        prevFeatures.map((feature) =>
          feature._id === editFeature._id ? editFeature : feature
        )
      );
      setEditFeature(null);
    } catch (err) {
      console.error("Error updating feature:", err);
      setError("Failed to update feature. Please try again later.");
    }
  };
  return (
    <>
      <h1 style={{ marginTop: '100px' }}>Delete or Update Why Us Feature</h1>
      <div className='deletewhyuscontainer'>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        {features.map((feature, index) => (
          <Card
            key={feature._id}
            style={{
              width: '18rem',
              backgroundColor: 'white',
              boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.09)',
              padding: '2rem',
              position: 'relative',
              overflow: 'hidden',
              borderRadius: '8px',
              border: '4px solid #7C3AED',
              minHeight: '30rem',
              display: 'flex',
              flexDirection: 'column',
              marginBottom: '20px'
            }}
          >
            <div
              style={{
                width: '6rem',
                height: '6rem',
                backgroundColor: '#7C3AED',
                borderRadius: '50%',
                position: 'absolute',
                top: '-30px',
                right: '-30px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <p style={{ color: 'white', fontSize: '1.5rem' }}>{index + 1}</p>
            </div>
            <div style={{ flexGrow: 1, textAlign: 'center' }}>
              <MdDesignServices size={48} color="#7C3AED" />
              <Card.Title style={{ fontWeight: 'bold', fontSize: '1.25rem' }}>{feature.title}</Card.Title>
              <Card.Text style={{ color: '#fff', fontSize: '0.875rem' }}>
                {feature.description}
              </Card.Text>
            </div>
            <div>
            <button
              className="contact-button"
              onClick={() => handleEdit(feature)}
            >
              Edit
            </button>
            <button
              className="contact-button"
              onClick={() => handleDelete(feature._id)}
            >
              Delete
            </button>

            </div>
          </Card>
        ))}

{editFeature && (
  <div className="feature-form-overlay">
    <form className="feature-form" onSubmit={handleSubmit}>
      <h2>Edit Feature</h2>
      <label>
        Title:
        <input
          type="text"
          value={editFeature.title}
          onChange={(e) =>
            setEditFeature({ ...editFeature, title: e.target.value })
          }
        />
      </label>
      <label>
        Description:
        <textarea
        rows={8}
          value={editFeature.description}
          onChange={(e) =>
            setEditFeature({ ...editFeature, description: e.target.value })
          }
        />
      </label>
      <button type="submit" className="contact-button">
        Save
      </button>
      <button
        type="button"
        className="contact-button"
        onClick={() => setEditFeature(null)}
      >
        Cancel
      </button>
    </form>
  </div>
)}

      </div>

    </>
  );
};

export default DeleteWhyUsCards;
